import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13325048"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["placeholder"]
const _hoisted_2 = ["placeholder"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon el-input__icon el-range__icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "200",
    height: "200",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M128 384v512h768V192H768v32a32 32 0 11-64 0v-32H320v32a32 32 0 01-64 0v-32H128v128h768v64H128zm192-256h384V96a32 32 0 1164 0v32h160a32 32 0 0132 32v768a32 32 0 01-32 32H96a32 32 0 01-32-32V160a32 32 0 0132-32h160V96a32 32 0 0164 0v32zm-32 384h64a32 32 0 010 64h-64a32 32 0 010-64zm0 192h64a32 32 0 110 64h-64a32 32 0 110-64zm192-192h64a32 32 0 010 64h-64a32 32 0 010-64zm0 192h64a32 32 0 110 64h-64a32 32 0 110-64zm192-192h64a32 32 0 110 64h-64a32 32 0 110-64zm0 192h64a32 32 0 110 64h-64a32 32 0 110-64z"
    })
  ])
], -1))
const _hoisted_4 = {
  key: 0,
  class: "el-picker-panel__sidebar sidebar"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "el-picker-panel__body d-flex" }
const _hoisted_7 = { class: "_inner leftPanel" }
const _hoisted_8 = { class: "_inner panelHead" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "200",
    height: "200",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M529.408 149.376a29.12 29.12 0 0141.728 0 30.592 30.592 0 010 42.688L259.264 511.936l311.872 319.936a30.592 30.592 0 01-.512 43.264 29.12 29.12 0 01-41.216-.512L197.76 534.272a32 32 0 010-44.672l331.648-340.224zm256 0a29.12 29.12 0 0141.728 0 30.592 30.592 0 010 42.688L515.264 511.936l311.872 319.936a30.592 30.592 0 01-.512 43.264 29.12 29.12 0 01-41.216-.512L453.76 534.272a32 32 0 010-44.672l331.648-340.224z"
    })
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "_inner panelContent" }
const _hoisted_12 = ["onClick", "onMouseover"]
const _hoisted_13 = { class: "_inner rightPanel" }
const _hoisted_14 = { class: "_inner panelHead" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "el-icon" }, [
  /*#__PURE__*/_createElementVNode("svg", {
    class: "icon",
    width: "200",
    height: "200",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M452.864 149.312a29.12 29.12 0 0141.728.064L826.24 489.664a32 32 0 010 44.672L494.592 874.624a29.12 29.12 0 01-41.728 0 30.592 30.592 0 010-42.752L764.736 512 452.864 192a30.592 30.592 0 010-42.688zm-256 0a29.12 29.12 0 0141.728.064L570.24 489.664a32 32 0 010 44.672L238.592 874.624a29.12 29.12 0 01-41.728 0 30.592 30.592 0 010-42.752L508.736 512 196.864 192a30.592 30.592 0 010-42.688z"
    })
  ])
], -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "_inner panelContent" }
const _hoisted_18 = ["onClick", "onMouseover"]

import {
  computed,
  getCurrentInstance,
  nextTick,
  onBeforeMount,
  onBeforeUnmount,
  onMounted,
  reactive,
  ref,
} from "vue";
import { onClickOutside } from "@vueuse/core";

interface Emits {
  (e: "updateTimeRange", startYear: number, endYear: number): void;
}
interface Props {
  labelWidth: number;
  labelText: string;
  sp?: string;
  initYear?: { startYear: number; endYear: number };
  disabled?: boolean;
  shortcuts?: any;
  disabledDate?: any;
}
type VNodeRef = typeof vnodeRef;


export default /*#__PURE__*/_defineComponent({
  props: {
    labelWidth: { default: 0 },
    labelText: { default: "" },
    sp: { default: "-" },
    initYear: null,
    disabled: { type: Boolean, default: false },
    shortcuts: { default: [] },
    disabledDate: { default() {
    return () => false;
  } }
  },
  emits: ["updateTimeRange"],
  setup(__props: any, { expose, emit: emits }: { emit: ({
  (e: "updateTimeRange", startYear: number, endYear: number): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { labelWidth: number, labelText: string, sp: string, initYear?: { startYear: number; endYear: number }, disabled: boolean, shortcuts: any, disabledDate: any }

const SELECT_STATE = {
  unselect: 0,
  selecting: 1,
  selected: 2,
};

const data = reactive<any>({
  itemBg: {},
  startShowYear: null,
  endShowYear: null,
  yearList: [],
  showPanel: false,
  startYear: null,
  endYear: null,
  curYear: 0,
  curSelectedYear: 0,
  curState: SELECT_STATE.unselect,
});

const vnodeRef = getCurrentInstance()?.vnode.ref || {};

const yearPicker = ref<VNodeRef>();
const inputLeft = ref<VNodeRef>();
const inputRight = ref<VNodeRef>();

const oneSelected = computed(() => {
  return (
    data.curState === SELECT_STATE.selecting &&
    (data.startYear === data.endYear || data.endYear == null)
  );
});

const leftYearList = computed(() => {
  return data.yearList.slice(0, 10);
});

const rightYearList = computed(() => {
  return data.yearList.slice(10, 20);
});

// eslint-disable-next-line no-undef


// eslint-disable-next-line no-undef


const clickInput = (e: any) => {
  e.stopPropagation();
  return false;
};

const checkValidYear = (iYear: number) => {
  if (props.initYear) {
    if (iYear > props.initYear.endYear) {
      return 1;
    } else if (iYear < props.initYear.startYear) {
      return -1;
    }
  }
  return 0;
};
const checkStartInput = () => {
  if (isNaN(data.startShowYear)) {
    data.startShowYear = data.startYear;
  } else {
    data.startYear = data.startShowYear * 1;
  }
};

const checkEndInput = () => {
  if (isNaN(data.endShowYear)) {
    data.endShowYear = data.endYear;
  } else {
    data.endYear = data.endShowYear * 1;
  }
};

const changeYear = () => {
  if (data.startYear > data.endYear) {
    let tmp = data.endYear;
    data.endYear = data.startYear;
    data.startYear = tmp;
  }
  if (props.initYear) {
    data.startYear = Math.max(data.startYear, props.initYear.startYear);
    data.endYear = Math.min(data.endYear, props.initYear.endYear);
  }
  data.startShowYear = data.startYear;
  data.endShowYear = data.endYear;

  if (data.startYear && data.endYear) {
    emits("updateTimeRange", data.startYear, data.endYear);
  } else {
    console.warn("WARN:年份不合法", data.startYear, data.endYear);
  }
};

const onHoverItem = (iYear: number) => {
  // if (checkValidYear(iYear) != 0) {
  //   return;
  // }
  if (data.curState === SELECT_STATE.selecting) {
    let tmpStart = data.curSelectedYear;
    data.endYear = Math.max(tmpStart, iYear);
    data.startYear = Math.min(tmpStart, iYear);
  }
};

const onClickItem = (iYear: number) => {
  if (checkValidYear(iYear) != 0) {
    return;
  }
  if (
    data.curState === SELECT_STATE.unselect ||
    data.curState === SELECT_STATE.selected
  ) {
    data.startYear = iYear;
    data.curSelectedYear = iYear;
    data.endYear = null;
    data.curState = SELECT_STATE.selecting;
  } else if (data.curState === SELECT_STATE.selecting) {
    data.endShowYear = data.endYear;
    data.startShowYear = data.startYear;
    data.curState = SELECT_STATE.selected;

    emits("updateTimeRange", data.startYear, data.endYear);
    data.showPanel = false;
  }
};

const updateYearRange = (start: number, end: number) => {
  data.startYear = start;
  data.startShowYear = start;
  data.endYear = end;
  data.endShowYear = end;
  data.curState = SELECT_STATE.selected;
};

const onFocus = () => {
  nextTick(() => {
    data.showPanel = true;
  });
};

const updateYearList = () => {
  let iStart = Math.floor(data.curYear / 10) * 10 - 10;
  iStart = iStart < 0 ? 0 : iStart;
  data.yearList = [];
  for (let index = 0; index < 20; index++) {
    data.yearList.push(iStart + index);
  }
};

const isAncestorFloatPanel = (element: HTMLElement): boolean => {
  while (element) {
    if (element.classList.contains("floatPanel")) {
      return true; // 如果找到 class="floatPanel" 的祖先元素，则返回 true
    }
    element = element.parentElement; // 否则，检查其父元素
  }
  return false; // 如果没有找到，返回 false
};

const isDateDisabled = (year: number) => {
  return props.disabledDate(year); // 调用父组件提供的disabled-date函数并返回结果
};
const close = onClickOutside(yearPicker, () => {
  data.showPanel = false;
});

// eslint-disable-next-line no-undef
const closePanel = (e: any) => {
  const target = e.target as HTMLElement;
  if (isAncestorFloatPanel(target)) {
    return;
  } else {
    data.showPanel = false;
  }
  return false;
};

const onClickLeft = () => {
  data.curYear = data.curYear * 1 - 10;
  updateYearList();
};

const onClickRight = () => {
  data.curYear = data.curYear * 1 + 10;
  updateYearList();
};

const onShortcuts = (fun: any) => {
  const shortcuts_data = fun();
  const startYear = new Date(shortcuts_data[0]).getFullYear();
  const endYear = new Date(shortcuts_data[1]).getFullYear();
  emits("updateTimeRange", startYear, endYear);
  data.showPanel = false;
};

// eslint-disable-next-line no-undef
expose({
  updateYearRange: updateYearRange,
});

onBeforeMount(() => {
  data.curYear = new Date().getFullYear();
  updateYearList();
});

onBeforeUnmount(() => {
  close && close();
  document.removeEventListener("click", closePanel.bind(data));
});

onMounted(() => {
  document.addEventListener("click", closePanel.bind(data));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['yearPicker', 'el-date-editor', { disabled: __props.disabled }]),
    ref_key: "yearPicker",
    ref: yearPicker
  }, [
    _createElementVNode("div", {
      class: "_inner",
      style: _normalizeStyle({ width: props.labelWidth + 'px' })
    }, _toDisplayString(props.labelText), 5),
    _withDirectives(_createElementVNode("input", {
      class: "_inner",
      ref_key: "inputLeft",
      ref: inputLeft,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(data).startShowYear) = $event)),
      onFocus: onFocus,
      onClick: clickInput,
      type: "text",
      name: "yearInput",
      onInput: _cache[1] || (_cache[1] = ($event: any) => (checkStartInput())),
      placeholder: _ctx.$t('common.dateStart')
    }, null, 40, _hoisted_1), [
      [_vModelText, _unref(data).startShowYear]
    ]),
    _createElementVNode("span", null, _toDisplayString(props.sp), 1),
    _withDirectives(_createElementVNode("input", {
      class: "_inner",
      ref_key: "inputRight",
      ref: inputRight,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(data).endShowYear) = $event)),
      onFocus: onFocus,
      onClick: clickInput,
      type: "text",
      name: "yearInput",
      onInput: _cache[3] || (_cache[3] = ($event: any) => (checkEndInput())),
      placeholder: _ctx.$t('common.dateEnd')
    }, null, 40, _hoisted_2), [
      [_vModelText, _unref(data).endShowYear]
    ]),
    _hoisted_3,
    _createElementVNode("div", {
      class: _normalizeClass(["_inner floatPanel el-date-range-picker", { open: _unref(data).showPanel }])
    }, [
      (__props.shortcuts)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.shortcuts, (shortcut) => {
              return (_openBlock(), _createElementBlock("button", {
                key: shortcut.text,
                onClick: ($event: any) => (onShortcuts(shortcut.value)),
                type: "button",
                class: "el-picker-panel__shortcut"
              }, _toDisplayString(shortcut.text), 9, _hoisted_5))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("button", {
              type: "button",
              onClick: onClickLeft
            }, _hoisted_10),
            _createTextVNode(" " + _toDisplayString(_unref(leftYearList)[0] + "-" + _unref(leftYearList)[9]), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(leftYearList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({
                disabled: checkValidYear(item) || isDateDisabled(item),
                oneSelected: item === _unref(data).startYear && _unref(oneSelected),
                startSelected: item === _unref(data).startYear,
                endSelected: item === _unref(data).endYear,
                _inner: true,
                betweenSelected: item > _unref(data).startYear && item < _unref(data).endYear,
              }),
                key: item
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass({
                  cell: true,
                  _inner: true,
                  selected: item === _unref(data).startYear || item === _unref(data).endYear,
                  disabled: isDateDisabled(item),
                }),
                  onClick: ($event: any) => (onClickItem(item)),
                  onMouseover: ($event: any) => (onHoverItem(item))
                }, _toDisplayString(item), 43, _hoisted_12)
              ], 2))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("button", {
              type: "button",
              onClick: onClickRight
            }, _hoisted_16),
            _createTextVNode(" " + _toDisplayString(_unref(rightYearList)[0] + "-" + _unref(rightYearList)[9]), 1)
          ]),
          _createElementVNode("div", _hoisted_17, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rightYearList), (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass({
                disabled: checkValidYear(item) || isDateDisabled(item),
                startSelected: item === _unref(data).startYear,
                endSelected: item === _unref(data).endYear,
                betweenSelected: item > _unref(data).startYear && item < _unref(data).endYear,
              }),
                key: item
              }, [
                _createElementVNode("a", {
                  class: _normalizeClass({
                  cell: true,
                  _inner: true,
                  selected: item === _unref(data).endYear || item === _unref(data).startYear,
                  disabled: isDateDisabled(item),
                }),
                  onClick: ($event: any) => (onClickItem(item)),
                  onMouseover: ($event: any) => (onHoverItem(item))
                }, _toDisplayString(item), 43, _hoisted_18)
              ], 2))
            }), 128))
          ])
        ])
      ])
    ], 2)
  ], 2))
}
}

})